<div class="close-btn-outer text-right">
  <button mat-raised-button color="warn" (click)="close()">
    <mat-icon class="ml-0 mr-0">close</mat-icon>
  </button>
</div>
<div class="full-desc lh">
  <ng-container *ngIf="!reviewed">
    <h3 class="mt-2">Leave your Review : {{product.name}}</h3>
    <div class="divider"></div>
    <p class="mt-2 text-muted">Your email address will not be published. Required fields are marked *</p>
    <form [formGroup]="reviewForm" class="d-flex flex-row flex-wrap">
      <h3 class="flex-100 justify-content-start align-items-center mt-2">
        <span>Select Your Rating:
          <br class="d-md-none" />
          <span>
            <mat-icon [color]="noStars > 0 ? 'primary':'accent'" class="mat-icon-lg" (click)="changeRating(1)">star</mat-icon>
            <mat-icon [color]="noStars > 1 ? 'primary':'accent'" class="mat-icon-lg" (click)="changeRating(2)">star</mat-icon>
            <mat-icon [color]="noStars > 2 ? 'primary':'accent'" class="mat-icon-lg" (click)="changeRating(3)">star</mat-icon>
            <mat-icon [color]="noStars > 3 ? 'primary':'accent'" class="mat-icon-lg" (click)="changeRating(4)">star</mat-icon>
            <mat-icon [color]="noStars > 4 ? 'primary':'accent'" class="mat-icon-lg" (click)="changeRating(5)">star</mat-icon>
          </span>
        </span>
      </h3>
      <div class="flex-100 d-flex flex-row flex-wrap p-1 review-options justify-content-start align-items-center">
        <div class="flex-100 review-options">
          <mat-radio-group formControlName="rating" required name="rating" class="d-flex flex-row" (change)="changeStars($event)">
            <mat-radio-button class="flex-auto" color="primary" value="1" [checked]="noStars === 1">
              <div class="review-option">
                <mat-icon class="review-rating mat-icon-lg" matTooltip="Very Dissatisfied" matTooltipPosition="below">sentiment_very_dissatisfied</mat-icon>
                <span class="d-none d-md-block">Very Dissatisfied</span>
              </div>
            </mat-radio-button>
            <mat-radio-button class="flex-auto" color="primary" value="2" [checked]="noStars === 2">
              <div class="review-option">
                <mat-icon class="review-rating mat-icon-lg" matTooltip="Dissatisfied" matTooltipPosition="below">sentiment_dissatisfied</mat-icon>
                <span class="d-none d-md-block">Dissatisfied</span>
              </div>
            </mat-radio-button>
            <mat-radio-button class="flex-auto" color="primary" value="3" [checked]="noStars === 3">
              <div class="review-option">
                <mat-icon class="review-rating mat-icon-lg" matTooltip="Neutral" matTooltipPosition="below">sentiment_neutral</mat-icon>
                <span class="d-none d-md-block">Neutral</span>
              </div>
            </mat-radio-button>
            <mat-radio-button class="flex-auto" color="primary" value="4" [checked]="noStars === 4">
              <div class="review-option">
                <mat-icon class="review-rating mat-icon-lg" matTooltip="Satisfied" matTooltipPosition="below">sentiment_satisfied</mat-icon>
                <span class="d-none d-md-block">Satisfied</span>
              </div>
            </mat-radio-button>
            <mat-radio-button class="flex-auto" color="primary" value="5" [checked]="noStars === 5">
              <div class="review-option">
                <mat-icon class="review-rating mat-icon-lg" matTooltip="Very Satisfied" matTooltipPosition="below">sentiment_very_satisfied</mat-icon>
                <span class="d-none d-md-block">Very Satisfied</span>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="flex-100">
          <mat-error *ngIf="reviewForm.controls.rating.errors?.required">Please select a rating</mat-error>
        </div>
      </div>
      <div class="flex-100 px-1 mt-1">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Your review title</mat-label>
          <input matInput placeholder="Your review" formControlName="title" required rows="5" />
          <mat-error *ngIf="reviewForm.controls.title.errors?.required">Review title is required</mat-error>
        </mat-form-field>
      </div>
      <div class="flex-100 px-1 mt-1">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Your review</mat-label>
          <textarea matInput placeholder="Your review" formControlName="reviewText" required rows="5"></textarea>
          <mat-error *ngIf="reviewForm.controls.reviewText.errors?.required">Review Text is required</mat-error>
        </mat-form-field>
      </div>
      <div class="flex-100 flex-md-50 px-1 mt-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Your name</mat-label>
          <input matInput placeholder="Your name" formControlName="name" required>
          <mat-error *ngIf="reviewForm.controls.name.errors?.required">Name is required</mat-error>
        </mat-form-field>
      </div>
      <div class="flex-100 flex-md-50 px-1 mt-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Your email</mat-label>
          <input matInput placeholder="Your email" formControlName="email" required>
          <mat-error *ngIf="reviewForm.controls.email.errors">Invalid email address</mat-error>
        </mat-form-field>
      </div>
      <div class="flex-100 mt-2 mb-3 text-center w-100">
        <button mat-raised-button color="accent" (click)="close()" class="mr-2">Cancel</button>
        <button mat-raised-button color="primary" type="submit" (click)="onReviewSubmit()" class="ml-2">Submit Review</button>
      </div>
    </form>
  </ng-container>
</div>
